module.exports = __webpack_public_path__ + "img/coming-soon.de83ae79.png";